import { BOARD_TYPE, IBoardConfig, IKilledKukari, IKukariPositionData, IMovingKukari, IScoreFlyAnimationConfigForPlayer, ISmoke, PLAYER_NUMBER } from "../../pages/GamePlay/types";
import { StateType } from "./interface";
import _get from "lodash/get";
import _forEach from "lodash/forEach";
import { BOARD_CONFIG, TWO_PLAYER_CONFIG } from "../../components/GamePlayComponents/constant";
import { _has, _includes, _isNil, _reduce } from "../../utils/helpers/zupeeLodash";
import { store } from "..";

export function getPlayersInfo(state: StateType) {
  return _get(state, "ludoboard.tableInfo.pi", []);
}

export function getTotalPlayers(state: StateType) {
  return _get(state, 'ludoboard.tableInfo.totalPlayers', 0)
}

export function getBoardType(state: StateType): BOARD_TYPE {
  return _get(state, 'ludoboard.tableInfo.boardType', BOARD_TYPE.DEFAULT_BOARD)
}

export function getDiceValue(state: StateType) {
  return _get(state, 'ludoboard.tableInfo.dv', null)
}

export function getMovingKukari(state: StateType) {
  return _get(state, 'ludoboard.tableInfo.movingKukari', null)
}
export function getKilledKukari(state: StateType) {
  return _get(state, 'ludoboard.tableInfo.killedKukari', null)
}
export function getTurnSi(state: StateType): number | null | undefined {
  return _get(state, 'ludoboard.tableInfo.turnSi')
}
export function getBounceAnimation(state: StateType): boolean {
  return _get(state, 'ludoboard.tableInfo.bounceAnimation', false)
}
export function getMySeatIndex(state: StateType): number | null | undefined {
  return _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.ONE}`, null)
}

export function getIsKukariScoreVisible(state: StateType): boolean {
  return _get(state, 'ludoboard.tableInfo.isKukariScoreVisible')
}

export function getIsTtsix(state: StateType): boolean {
  return _get(state, 'ludoboard.tableInfo.IsTtsix', false)
}

export function getTimeLeft(state: StateType) {
  return _get(state, 'ludoboard.tableInfo.timeLeft')
}

export function getTotalTurnTime(state: StateType) {
  return _get(state, 'ludoboard.tableInfo.stt', 15)
}

export function getStartDice(state: StateType) {
  return _get(state, 'ludoboard.tableInfo.startDice', null)
}

export function getTst(state: StateType): string | null {
  return _get(state, 'ludoboard.tableInfo.tst', null) as string | null
}

export function getResetTimer(state: StateType) {
  return _get(state, 'ludoboard.tableInfo.resetTimer', 0)
}

export function getIsMySeatIndex(playerNumber: PLAYER_NUMBER, state: StateType): boolean {
  return _get(state, `ludoboard.tableInfo.${playerNumber}`) === getMySeatIndex(state)
}

export function getShowTurnTimer(state: StateType) {
  return _get(state, 'ludoboard.tableInfo.showTurnTimer', false)
}

export function getTripleSixAnimation(state: StateType): boolean {
  return _get(state, 'ludoboard.tableInfo.tripleSixAnimation')
}

export function getShowExtraMoveNudge(state: StateType): boolean {
  return _get(state, 'ludoboard.tableInfo.showExtraMoveNudge', false)
}

export function getTimeBankTimeLeft(state: StateType) {
  return _get(state, 'ludoboard.tableInfo.timeBankTimeLeft', 0)
}

export function getIsTimeBankVisible(state: StateType): boolean {
  return _get(state, 'ludoboard.tableInfo.isTimeBankVisible', false)
}

export function getNxUserInfoData(state: StateType): object {
  return _get(state, 'ludoboard.tableInfo.pgi')
}

export function getIsSkipTooltipVisible(state: StateType): boolean {
  return _get(state, 'ludoboard.tableInfo.isSkipTooltipVisible')
}

export function getTotalTimeBankTime(state: StateType): number {
  return _get(state, 'ludoboard.tableInfo.totalTimeBankTime')
}

export function getIsScoreRevealAnimationVisible(state: StateType): boolean {
  return _get(state, 'ludoboard.tableInfo.isScoreRevealAnimationVisible')
}

export function getSmoke(state: StateType): ISmoke | null {
  return _get(state, 'ludoboard.tableInfo.smoke', null)
}

export function getCoinAnimation(state: StateType): boolean {
  return _get(state, 'ludoboard.tableInfo.coinAnimation', false)
}

export function getMovableKukaris(state: StateType) {
  const turnSi = getTurnSi(state) as number
  const startBounceAnimation = getBounceAnimation(state)
  const pInfo = getPlayersInfo(state)?.[turnSi]
  const diceValue = getDiceValue(state) as number
  const mySeatIndex = getMySeatIndex(state)
  const boardConfig: IBoardConfig = BOARD_CONFIG[getBoardType(state)] ?? TWO_PLAYER_CONFIG

  const movableKukaris: number[] = []

  if (startBounceAnimation && mySeatIndex === turnSi) {
    _forEach(pInfo?.dvp, (v: number, i: number) => {
      if (v + diceValue + 1 <= boardConfig?.PATH_FINAL_INDEX) {
        movableKukaris.push(i)
      }
    })
  }

  return movableKukaris
}

// get all kukri positions except for movingKukri and killedKukri as they will be rendered in animation components
function _placeKukriForPlayer(
  data: IKukariPositionData,
  playerNumber: PLAYER_NUMBER,
  movingKukari: IMovingKukari,
  killedKukari: IKilledKukari,
  movableKukaris: number[],
  isKukariScoreVisible: boolean = false,
  position: number,
  index: number
): void {

  // console.log({data, playerNumber, movingKukari, killedKukari, movableKukaris, position, index}, 'yoyoyoyoyoyo');

  if (
    (playerNumber !== movingKukari?.playerNumber || index !== movingKukari?.tokenIndex) &&
    (playerNumber !== killedKukari?.playerNumber || index !== killedKukari?.tokenIndex)
  )
    if (position <= data.boardConfig.OUTER_PATH_LENGTH - 2) {
      const pos = ((data.boardConfig.START_POSITIONS[playerNumber] as number) + position) % data.boardConfig.OUTER_PATH_LENGTH
      if (!_has(data.commonBoxes, pos)) {
        data.commonBoxes[pos] = []
      }
      data.commonBoxes[pos].push({
        playerNumber,
        i: index,
        score: position,
        isMovable: playerNumber === PLAYER_NUMBER.ONE && _includes(movableKukaris, index)
      })
    } else if (position <= data.boardConfig.PATH_FINAL_INDEX - 1) {
      if (!_has(data.homeBoxes[playerNumber], position - (data.boardConfig.OUTER_PATH_LENGTH - 1))) {
        data.homeBoxes[playerNumber][position - (data.boardConfig.OUTER_PATH_LENGTH - 1)] = []
      }
      data.homeBoxes[playerNumber][position - (data.boardConfig.OUTER_PATH_LENGTH - 1)].push({
        i: index,
        isMovable: playerNumber === PLAYER_NUMBER.ONE && _includes(movableKukaris, index),
        playerNumber: undefined
      })
    } else if (position === data.boardConfig.PATH_FINAL_INDEX) {
      data.finalBoxes[playerNumber].push(index)
    }
}


export function getAllKukariPositions(state: StateType) {
  const pi = getPlayersInfo(state)
  const movingKukari = getMovingKukari(state)
  const killedKukari = getKilledKukari(state)
  const movableKukaris = getMovableKukaris(state)
  const isKukariScoreVisible = getIsKukariScoreVisible(state)

  const data: IKukariPositionData = {
    boardConfig: TWO_PLAYER_CONFIG as IBoardConfig,
    commonBoxes: {},
    homeBoxes: { [PLAYER_NUMBER.ONE]: {}, [PLAYER_NUMBER.TWO]: {}, [PLAYER_NUMBER.THREE]: {}, [PLAYER_NUMBER.FOUR]: {} },
    finalBoxes: { [PLAYER_NUMBER.ONE]: [], [PLAYER_NUMBER.TWO]: [], [PLAYER_NUMBER.THREE]: [], [PLAYER_NUMBER.FOUR]: [] }
  }



  if (!pi) return data

  let si: undefined | number | null = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.TWO}`)
  !_isNil(si) &&
    _forEach(
      pi[si]?.dvp,
      (position, index) => {
      _placeKukriForPlayer(data, PLAYER_NUMBER.TWO, movingKukari, killedKukari, movableKukaris,isKukariScoreVisible, position, index)}
    )

  si = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.THREE}`)
  !_isNil(si) &&
    _forEach(
      pi[si]?.dvp,
      (position, index) => {
        _placeKukriForPlayer(data, PLAYER_NUMBER.THREE, movingKukari, killedKukari, movableKukaris,isKukariScoreVisible, position, index)}
    )

  si = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.FOUR}`)
  !_isNil(si) &&
    _forEach(
      pi[si]?.dvp,
      (position, index) => {
        _placeKukriForPlayer(data, PLAYER_NUMBER.FOUR, movingKukari, killedKukari, movableKukaris,isKukariScoreVisible, position, index)}
    )

  si = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.ONE}`)
  !_isNil(si) &&
    _forEach(pi[si]?.dvp, (position, index) => {
      _placeKukriForPlayer(data, PLAYER_NUMBER.ONE, movingKukari, killedKukari, movableKukaris,isKukariScoreVisible, position, index)})

  // data.coloredBoxes = getColoredBoxes(state)

  return data
}

export function getScoreFlyAnimationConfig(
  playerNumber: PLAYER_NUMBER,
  state: StateType
): IScoreFlyAnimationConfigForPlayer | null {
  return _get(state, `ludoboard.tableInfo.scoreFlyAnimationConfig[${playerNumber}]`, null)
}

function getKukarisForPlayerAtPosition(
  position: number,
  si: number,
  startPosition: number,
  outerPathLength: number,
  dvp?: Array<number>
) {
  return _reduce(
    dvp,
    (vres, tPos) => {
      if (tPos <= outerPathLength - 2 && (tPos + startPosition) % outerPathLength === position) {
        return vres + 1
      }
      return vres
    },
    0
  )
}

export function getKukarisAtPosition(position: number, state: StateType): number {
  const pi = getPlayersInfo(state)
  const boardType = getBoardType(state)
  const boardConfig = BOARD_CONFIG[boardType] ?? TWO_PLAYER_CONFIG as IBoardConfig

  if (!pi) return 0

  let res = 0

  let si = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.ONE}`)
  if (!_isNil(si)) {
    res =
      res +
      getKukarisForPlayerAtPosition(
        position,
        si,
        boardConfig.START_POSITIONS[PLAYER_NUMBER.ONE] || 0,
        boardConfig.OUTER_PATH_LENGTH,
        pi[si]?.dvp
      )
  }

  si = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.TWO}`)
  if (!_isNil(si)) {
    res =
      res +
      getKukarisForPlayerAtPosition(
        position,
        si,
        boardConfig.START_POSITIONS[PLAYER_NUMBER.TWO] || 0,
        boardConfig.OUTER_PATH_LENGTH,
        pi[si]?.dvp
      )
  }

  si = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.THREE}`)
  if (!_isNil(si)) {
    res =
      res +
      getKukarisForPlayerAtPosition(
        position,
        si,
        boardConfig.START_POSITIONS[PLAYER_NUMBER.THREE] || 0,
        boardConfig.OUTER_PATH_LENGTH,
        pi[si]?.dvp
      )
  }

  si = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.FOUR}`)
  if (!_isNil(si)) {
    res =
      res +
      getKukarisForPlayerAtPosition(
        position,
        si,
        boardConfig.START_POSITIONS[PLAYER_NUMBER.FOUR] || 0,
        boardConfig.OUTER_PATH_LENGTH,
        pi[si]?.dvp
      )
  }

  return res
}

export function getExtraPointForHomeEnabled(state: StateType): boolean {
  return _get(state, 'ludoboard.tableInfo.extraPointForHomeEnabled', false)
}

export function getTokenPosition(si: number | null, playerNumber: number, tokenIndex: number, state: StateType): number | null {
  const currSi = !_isNil(si) ? si : _get(state, `ludoboard.tableInfo.${playerNumber}`)

  return _get(state, `ludoboard.tableInfo.pi.${currSi}.dvp.${tokenIndex}`, null)
}

export function getFinalMovePlayers(state: StateType) {
  return _get(state, 'ludoboard.tableInfo.finalMovePlayers', [])
}

export function getLeftPlayers(state: StateType) {
  return _get(state, 'ludoboard.tableInfo.leftPlayers', [])
}

export function getCurrentPlayerTurnCount(state: StateType): number {
  return _get(state, 'ludoboard.tableInfo.currentPlayerTurnCount', 0)
}

export function getMaxCurrentUserTurnAnimation(state: StateType): number {
  return _get(state, 'ludoboard.tableInfo.ftcpData.maxCurrentUserTurnAnimation', 0)
}

export function getMaxOtherUserTurnAnimation(state: StateType): number {
  return _get(state, 'ludoboard.tableInfo.ftcpData.maxOtherUserTurnAnimation', 0)
}

export function getShouldShowScoreAnimation(playerNumber: PLAYER_NUMBER, state: StateType): boolean {
  const _turnCount = getCurrentPlayerTurnCount(state)
  const maxUserTurnAnimation =
    playerNumber === PLAYER_NUMBER.ONE ? getMaxCurrentUserTurnAnimation(state) : getMaxOtherUserTurnAnimation(state)

  return (
    !_isNil(playerNumber) && 
    !_isNil(_turnCount) && 
    maxUserTurnAnimation > 0 && 
    _turnCount < maxUserTurnAnimation
  )
}

export function getTableId(state: StateType): string {
  return _get(state, 'ludoboard.tableInfo._id', ''); // Default to an empty string
}

export function isVoiceOverEnabled(state: StateType) {
  return _get(state, `ludoboard.tableInfo.ftcpData.isVoiceOverEnabled`)
}

export function getTimeLimitInSeconds(state: StateType) {
  return _get(state, `ludoboard.tableInfo.timeLimitInSecs`, 0) as number
}

export function getLtid(state: StateType): number | null {
  return _get(state, 'ludoboard.tableInfo.ltid', null)
}

export function getSerialNumber(state: StateType): number | null {
  return _get(state, 'app.serialNumber', null) as number | null
}

export function getUsername(state: any) {
  return state?.user?.userData?.un
}

export const getUserId = (state: any) => {
  return _get(state, 'user.gameUserId', '')
}
  
export function getHomeAnimationConfig(state: StateType) {
  return _get(state, 'ludoboard.tableInfo.homeAnimationConfig', null)
}

export function getHomeAnimationConfigNx(state: StateType) {
  return _get(state, 'ludoboard.tableInfo.homeAnimationConfigNx', null)
}